query HasImportedLeads {
  hasImportedLeads
}
